import { Box } from '@radix-ui/themes';
import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import { MachineContext, MachineDialogMode } from 'contexts/machine.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { SpecialMsPosition } from 'lib_ts/interfaces/machine-msg/i-special-mstarget';
import { useContext } from 'react';
import { DataCollectionsService } from 'services/data-collections.service';
import { useHardwareDiagnosticStore } from './store/use-hardware-diagnostic-store';

export const HardwareDiagnosticCancelConfirm = () => {
  const cancelConfirmKey = useHardwareDiagnosticStore(
    (s) => s.cancelConfirmKey
  );
  const inProgressHwd = useHardwareDiagnosticStore((s) => s.inProgressHwd);
  const dismissCancelConfirm = useHardwareDiagnosticStore(
    (s) => s.dismissCancelConfirm
  );
  const setInProgressHwd = useHardwareDiagnosticStore(
    (s) => s.setInProgressHwd
  );

  const {
    setAutoFire,
    specialMsTarget,
    closeDialog,
    onCancelHwd,
    reloadLastDcComplete,
  } = useContext(MachineContext);

  if (!cancelConfirmKey || !inProgressHwd) {
    return null;
  }

  return (
    <CommonConfirmationDialog
      key={cancelConfirmKey}
      identifier="HardwareDiagnosticCancelConfirm"
      title="common.warning"
      content={
        <Box>
          This will quit the process and all data will be lost. Do you want to
          continue?
        </Box>
      }
      action={{
        label: 'common.continue',
        color: RADIX.COLOR.DANGER,
        onClick: async () => {
          setAutoFire(false);

          await DataCollectionsService.updateOne(inProgressHwd._id, {
            cancelled: true,
          });

          dismissCancelConfirm();
          setInProgressHwd(undefined);

          specialMsTarget(SpecialMsPosition.lowered);
          closeDialog(MachineDialogMode.HwDiagnostic);
          onCancelHwd();
          reloadLastDcComplete();
        },
      }}
      cancel={{
        label: 'common.close',
        onClick: () => {
          dismissCancelConfirm();
        },
      }}
    />
  );
};
